import { useForm, Controller } from 'react-hook-form'
import { FormInput, FormDialog } from '../../components/ui'

interface AccountFormProps {
  open: boolean
  onClose: () => void
  onSubmit: (data: any) => void
  initialData?: any
}

export const AccountForm = ({ open, onClose, onSubmit, initialData }: AccountFormProps) => {
  const { control, handleSubmit, reset, formState: { errors, isSubmitting } } = useForm({
    defaultValues: initialData || {
      name:        '',
      industry:    '',
      website:     '',
      phone:       '',
      description: '',
    },
  })

  const handleClose = () => {
    reset()
    onClose()
  }

  const handleFormSubmit = (data: any) => {
    onSubmit({ ...data, owner: 'Sarah Johnson' })
    handleClose()
  }

  return (
    <FormDialog
      open={open}
      onClose={handleClose}
      onSave={handleSubmit(handleFormSubmit)}
      title={initialData ? 'Edit Account' : 'New Account'}
      saving={isSubmitting}
      maxWidth="sm"
    >
      <Controller
        name="name"
        control={control}
        render={({ field }) => (
          <FormInput
            {...field}
            label="Account Name"
            required
            fieldType="name"
            placeholder="e.g. Acme Corporation"
            error={!!errors.name}
            helperText={errors.name?.message as string}
          />
        )}
      />

      <Controller
        name="industry"
        control={control}
        render={({ field }) => (
          <FormInput
            {...field}
            label="Industry"
            placeholder="e.g. Technology, Finance"
            error={!!errors.industry}
            helperText={errors.industry?.message as string}
          />
        )}
      />

      <Controller
        name="website"
        control={control}
        render={({ field }) => (
          <FormInput
            {...field}
            label="Website"
            fieldType="url"
            placeholder="https://example.com"
            error={!!errors.website}
            helperText={errors.website?.message as string}
          />
        )}
      />

      <Controller
        name="phone"
        control={control}
        render={({ field }) => (
          <FormInput
            {...field}
            label="Phone"
            fieldType="phone"
            placeholder="e.g. 9876543210"
            error={!!errors.phone}
            helperText={errors.phone?.message as string}
          />
        )}
      />

      <Controller
        name="description"
        control={control}
        render={({ field }) => (
          <FormInput
            {...field}
            label="Description"
            multiline
            rows={3}
            placeholder="Brief description of the account…"
            error={!!errors.description}
            helperText={errors.description?.message as string}
          />
        )}
      />
    </FormDialog>
  )
}
